import { AfterViewInit, Component, Input } from '@angular/core'
import { NbDialogRef } from '@nebular/theme'

import { CommonModule } from '@angular/common'
import { MatIconModule } from '@angular/material/icon'
import { Registration } from '@app/modules/database/models/registration.model'
import { DatabaseService } from '@app/modules/database/services/database.service'
import { ServerRepresentedEvent } from '@app/modules/events/models/event.model'
import { RevisionRequestModalComponent } from '../../../revision-request-modal/revision-request-modal.component'
/**
 * Displays a toggle switch or a drop down menu based on registration approval state
 */
@Component({
  selector: 'ngx-request-change-history',
  templateUrl: './request-changes-history.component.html',
  styleUrls: ['./request-changes-history.component.scss'],
  imports: [CommonModule, MatIconModule]
})
export class RequestChangesHistoryComponent implements AfterViewInit {
  @Input() registrant: Registration
  @Input() event: ServerRepresentedEvent
  loaded = false

  constructor(
    private dialogRef: NbDialogRef<RevisionRequestModalComponent>,
    private databaseService: DatabaseService
  ) {}
  ngAfterViewInit(): void {
    this.loaded = true
    this.registrant['_source']['revision_requests'].sort((a, b) => {
      return (new Date(b.created_at) as any) - (new Date(a.created_at) as any)
    })
  }
  close() {
    this.dialogRef.close()
  }
}
